import { signOut as ampSignOut } from "aws-amplify/auth";

type LogoutFn = (args?: { variables?: { email?: string } }) => Promise<unknown>;

type UseLogoutHook = (opts?: {
  onCompleted?: () => void;
  onError?: (e: unknown) => void;
}) => [LogoutFn, { loading: boolean }];

export const useLogoutUserMutation: UseLogoutHook = (opts) => {
  const fire: LogoutFn = async () => {
    try {
      await ampSignOut();
      opts?.onCompleted?.();
    } catch (e) {
      opts?.onError?.(e);
    }
  };
  return [fire, { loading: false }];
};
